import { render, staticRenderFns } from "./crowdMarketing.vue?vue&type=template&id=6cf8d57b&scoped=true&"
import script from "./crowdMarketing.vue?vue&type=script&lang=js&"
export * from "./crowdMarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf8d57b",
  null
  
)

component.options.__file = "crowdMarketing.vue"
export default component.exports